<template>
  <div class="intro">
    <h1 class="title">Comment trouver mon titre de transport&nbsp;?​</h1>
    <p class="text">Dites-nous tout et nous vous conseillerons le titre de transport le plus économique et le plus adapté à votre besoin.</p>
    <button type="button" class="btn -active -start" :class="{ '-disabled': isLoading }" @click="onClickStart">Commencer</button>
    <a class="btn -abo -secondary" href="https://shop.t-l.ch/fr/shop/search/by-zone" target="_blank" @click="onClickBuyAbo">Acheter mon titre de transport maintenant​</a>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'Intro',
  props: {
    data: []
  },
  computed: {
    ...mapState([
        'isLoading'
    ])
  },
  created() {
    if(this.$gtm) {
      this.$gtm.trackEvent(({
        category: 'Steps',
        action: 'click',
        label: 'Intro'
      }))
    }
  },
  methods: {
    ...mapMutations([
        'SET_STARTED'
    ]),
    onClickStart() {
      this.SET_STARTED(true)
    },
    onClickBuyAbo() {
      if(this.$gtm) {
        if(this.$gtm) {
          this.$gtm.trackEvent(({
            category: 'General',
            action: 'click',
            label: 'AchatAbo'
          }))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use '~@wide/styles-utils' as *;
@import '@/assets/scss/variables';

.intro {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  .title {
    text-align: center;
  }

  .text {
    max-width: 650px;
    text-align: center;
  }

  .btn {
    padding: 0;
    width: 100%;

    @include bp-up(md) {
      width: 35rem;
    }

    &.-start {
      margin-top: 5rem;
    }
    &.-abo {
      margin-top: 1rem;
      font-weight: 500;
      font-size: 1.6rem;
    }
  }
}

</style>
